import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  lighter: {
    fontWeight: 'lighter',
  },

  normal: {
    fontWeight: 'normal',
  },

  bold: {
    fontWeight: 'bold',
  },

  disabled: {
    color: '#9E9E9E !important',
  },

  center: {
    textAlign: 'center',
  },
}));
